<script lang="ts">
import { AppointmentService } from "@/services";
import { ListenEvent } from "@/services/events/listen-event.decorator";
import { useUserStore } from "@/stores/modules";
import { handleError } from "@/utils/handleError";
import { notify } from "@/utils/notify";
import { Appointment, Consultation } from "@model/entities";
import { appointmentEditReason } from "@model/models";
import { Options, Vue } from "vue-property-decorator";

@Options({
    components: {},
})
export default class AppointmentUpdateReasonDialog extends Vue {
    user = useUserStore();
    open = false;
    loading = false;

    appiontmentId: Appointment["id"] = null;
    reason = "";

    @ListenEvent("appointment-update-reason-dialog:open")
    async handleOpen(appiontmentId: Consultation["id"]) {
        this.appiontmentId = appiontmentId;
        this.reason = "";
        this.open = true;
    }

    get appointmentEditReason() {
        return appointmentEditReason;
    }

    async handleClickSubmit() {
        if (!this.reason) {
            return notify.error("請填寫更新原因");
        }
        if (this.appiontmentId) {
            try {
                this.loading = true;
                await AppointmentService.updateReason({
                    id: this.appiontmentId,
                    reason: this.reason
                });
                notify.saved();
                this.open = false;
            } catch (e) {
                handleError(e);
            } finally {
                this.loading = false;
            }
        }
    }
    
    handleClickAddReason(reason) {
        this.reason = reason;
    }
}
</script>

<template lang="pug">
el-dialog(v-model="open" append-to-body width="70%" destroy-on-close)
    template(#header)
        div 更新原因
    .body
        el-form(label-position="top")
            el-form-item(label="更新原因")
                template(v-for="r in appointmentEditReason")
                    el-button(@click="handleClickAddReason(r)") {{ r }}
                el-input(v-model="reason" type="textarea" :autosize="{minRows: 4}")
            Button(type="primary" @click="handleClickSubmit" :loading="loading") 提交
</template>

<style lang="scss" scoped>
@import "@/assets/styles/common.scss";

:deep(.el-dialog__body) {
    padding-top: 0;
}
</style>
